/**
 * @desc 滚动逻辑 会话存档选择时间时 正序展示消息 定位到最早的消息 同时下滑加载更新的消息，
 * 未选择时间时 正序展示消息 定位到最新的消息 同时上滑加载更早的消息
 * */
export const scrollToFirstMessage = (
  searchParams,
  data = [],
  parentDomId = 'log-box'
) => {
  // 时间范围正序下滑加载
  // 第一次打开时默认跳到最下面 不是第一次时跳到第一条消息
  // 撤回消息不展示
  const realData = data?.filter((item) => Number(item.action) !== 2);
  // 时间范围正序下滑加载 同时定位到最早的消息
  const index = 0;
  // 需要定位到parent元素下的某一个元素
  let parent = document?.querySelector(`#${parentDomId}`);
  let firstMessageDom = parent?.querySelector(
    `#message-${realData?.[index]?.id}`
  );
  if (firstMessageDom) {
    const messageBox = parent.querySelector('.infinite-scroll-component');
    messageBox.style.overflowY = 'auto';
    let distance =
      searchParams?.pageNum === 1
        ? messageBox?.scrollHeight
        : firstMessageDom?.offsetTop;
    // 如果调用者指定了top值 使用调用者的top值
    if (searchParams?.top) {
      distance = searchParams?.top;
    }
    messageBox.scrollTo({
      top: distance,
    });
  }
};
